var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 5.6875V3L14 9.6875L3.3125 3V5.6875L14 12.3125L24.6875 5.6875ZM24.6875 0.3125C25.3958 0.3125 26 0.583333 26.5 1.125C27.0417 1.66667 27.3125 2.29167 27.3125 3V19C27.3125 19.7083 27.0417 20.3333 26.5 20.875C26 21.4167 25.3958 21.6875 24.6875 21.6875H3.3125C2.60417 21.6875 1.97917 21.4167 1.4375 20.875C0.9375 20.3333 0.6875 19.7083 0.6875 19V3C0.6875 2.29167 0.9375 1.66667 1.4375 1.125C1.97917 0.583333 2.60417 0.3125 3.3125 0.3125H24.6875Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9257595c4b51fe6f71c8348db001c63f.svg";
export { ForwardRef as ReactComponent };